// Catálogo completo de módulos asisant
// Cada módulo tiene una página de aterrizaje en /modulos/:slug

export const modulesData = [
  // ============ PARTNERS & COMMERCE ============
  {
    slug: 'partner-manager',
    name: 'Partner Manager',
    group: 'Partners & Commerce',
    icon: 'Handshake',
    tagline: 'Centro de mando para tu ecosistema de partners',
    description: 'Administra proveedores, mayoristas y alianzas con contratos, certificaciones y línea de tiempo de actividad unificada.',
    heroHighlight: 'Gestión 360° de proveedores y mayoristas',
    features: [
      { title: 'Fichas de partners', desc: 'Perfiles detallados con panel financiero, contactos especializados y actividad histórica.' },
      { title: 'Gestión de contratos', desc: 'Cargas de documentos, periodos de facturación, alertas de vencimiento y aprobaciones.' },
      { title: 'Catálogo de certificaciones', desc: 'Seguimiento de colaboradores certificados por partner y alertas de vencimientos.' },
      { title: 'Línea de tiempo', desc: 'Tareas, notas, hitos, cursos y comunicaciones de cada relación.' },
      { title: 'Roadmap tipo Gantt', desc: 'Visualización de todas las actividades y proyectos con partners.' },
      { title: 'Dashboard ejecutivo', desc: 'Widgets de top vendors, contratos por vencer y alertas de certificaciones.' },
    ],
    benefits: [
      'Centraliza la información de cientos de partners en un solo lugar',
      'Nunca pierdas una renovación de contrato o certificación',
      'Acelera procesos de auditoría con evidencia documental',
    ],
    targetUsers: 'Partners tecnológicos, gestores de alianzas, empresas que operan ecosistemas de proveedores.',
  },
  {
    slug: 'csp-billing',
    name: 'CSP & Billing',
    group: 'Partners & Commerce',
    icon: 'Cloud',
    tagline: 'Operación CSP end-to-end con facturación multi-divisa',
    description: 'Plataforma completa para Cloud Solution Providers: ciclo de vida, suscripciones, licencias, consumo cloud y facturación con auditoría de márgenes.',
    heroHighlight: 'Microsoft · Azure · AWS · Acronis',
    features: [
      { title: 'Clientes con panel financiero', desc: 'Consumo pendiente Azure/AWS y workflows de aprovisionamiento.' },
      { title: 'Suscripciones multi-proveedor', desc: 'Microsoft CSP, Azure pago por uso, AWS y más.' },
      { title: 'Licencias sincronizadas', desc: 'Sincronización Microsoft, alertas de expiración y reportes.' },
      { title: 'Facturación multi-divisa', desc: 'Periodos, pagos, márgenes y generación automática desde suscripciones.' },
      { title: 'Asesor IA + Cotizador', desc: 'Cotizador con asistente conversacional, exportación PDF y conversión a factura.' },
      { title: 'Marketplace de autogestión', desc: 'Cuentas de cliente, catálogo publicable y compra recurrente.' },
      { title: 'Motor de workflows visuales', desc: 'Automatiza onboarding, alertas y renovaciones con React Flow.' },
      { title: 'Campos personalizados', desc: 'Extiende clientes, productos y suscripciones a tu operación.' },
    ],
    benefits: [
      'Factura todos los servicios cloud en un único flujo con márgenes auditables',
      'Reduce el tiempo de onboarding de clientes de días a minutos',
      'Observabilidad completa de workflows y logs de integración',
    ],
    targetUsers: 'Cloud Solution Providers (CSP), resellers de cloud, empresas de servicios gestionados (MSP).',
  },
  {
    slug: 'crm',
    name: 'CRM',
    group: 'Partners & Commerce',
    icon: 'Target',
    tagline: 'Gestión integral de clientes y pipeline comercial',
    description: 'Contactos, cuentas, oportunidades y automatización de ventas en un CRM moderno integrado con el resto de la plataforma.',
    heroHighlight: 'Unificado con tu billing y marketplace',
    features: [
      { title: 'Contactos y cuentas', desc: 'Ficha 360° de cada cliente con historial unificado.' },
      { title: 'Oportunidades', desc: 'Seguimiento del embudo de ventas con etapas personalizables.' },
      { title: 'Pipeline visual', desc: 'Vista Kanban del pipeline con forecast automático.' },
      { title: 'Automatización comercial', desc: 'Secuencias, recordatorios y tareas automáticas.' },
      { title: 'Reportes de ventas', desc: 'KPIs, conversión por etapa y análisis de cohortes.' },
    ],
    benefits: [
      'Una sola fuente de verdad para marketing, ventas y post-venta',
      'Integración nativa con facturación y soporte',
      'Automatiza follow-ups y nunca pierdas una oportunidad',
    ],
    targetUsers: 'Equipos de ventas, departamentos comerciales, gerentes de ventas.',
  },

  // ============ IT OPERATIONS ============
  {
    slug: 'itam-sam',
    name: 'IT Asset Management',
    group: 'IT Operations',
    icon: 'Boxes',
    tagline: 'Visibilidad total de hardware, software y licencias',
    description: 'Visibilidad total de hardware, software, licencias EA, SaaS y posición de cumplimiento (ELP) con motor de reglas por fabricante.',
    heroHighlight: 'ELP · Reconciliación · Auditoría',
    features: [
      { title: 'Inventario de hardware', desc: 'CPU, cores, sockets, virtualización, host y última señal de uso.' },
      { title: 'Catálogo de software', desc: 'Publishers, productos, ediciones y métricas de licencia.' },
      { title: 'Enterprise Agreements', desc: 'Pools, ventana de renegociación y alertas de renovación.' },
      { title: 'ELP automático', desc: 'Reconcilia entitlements vs instalaciones aplicando la regla del fabricante.' },
      { title: 'SaaS Management', desc: 'Seats activos 30d, utilización y detección de shadow IT.' },
      { title: 'SAM Advisor (IA)', desc: 'Propone acciones: reclaim, downgrade, consolidate, renegotiate, retire.' },
      { title: 'Auditorías listas', desc: 'Reportes con formato Microsoft MLS, Cisco SLR, Oracle y más.' },
      { title: 'Motor de reglas', desc: 'Per-core con mínimos, CAL, Oracle core factor, IBM PVU, FortiCare.' },
    ],
    benefits: [
      'Ahorros típicos del 15-30% en el primer año por rightsizing',
      'Pasa auditorías de fabricantes sin sorpresas',
      'Detecta shadow IT y licencias inactivas automáticamente',
    ],
    targetUsers: 'Empresas con grandes infraestructuras de TI, equipos de licenciamiento, auditores internos.',
  },
  {
    slug: 'uptime-manager',
    name: 'Uptime Manager',
    group: 'IT Operations',
    icon: 'Activity',
    tagline: 'Monitoreo de disponibilidad 24/7',
    description: 'Pings cada 5 minutos con histórico, latencias, alertas y reportes de SLA verificables para sitios, servidores y APIs.',
    heroHighlight: 'SLA verificable · Alertas en tiempo real',
    features: [
      { title: 'Monitores HTTP/HTTPS', desc: 'Configuración por umbral y geografía.' },
      { title: 'Logs históricos', desc: 'Tabla y gráficos de tiempos de respuesta.' },
      { title: 'Reportes de uptime', desc: 'Exportables y verificables públicamente.' },
      { title: 'Alertas configurables', desc: 'Email, webhook y panel de salud consolidado.' },
    ],
    benefits: [
      'Cumple compromisos de SLA con evidencia pública',
      'Reduce MTTR con alertas tempranas',
      'Dashboard ejecutivo de salud de flota',
    ],
    targetUsers: 'Operaciones de TI, administradores de sistemas, empresas con servicios online críticos.',
  },
  {
    slug: 'itsm',
    name: 'IT Service Management (ITSM)',
    group: 'IT Operations',
    icon: 'Workflow',
    tagline: 'Gestión ITIL moderna de servicios de TI',
    description: 'Incidentes, problemas, cambios y solicitudes con flujos ITIL, base de conocimiento y CMDB integrada.',
    heroHighlight: 'Incidentes · Cambios · Problemas · CMDB',
    features: [
      { title: 'Gestión de incidentes', desc: 'Workflow ITIL con priorización y escalamiento.' },
      { title: 'Gestión de cambios', desc: 'CAB, ventanas de cambio y aprobaciones.' },
      { title: 'Gestión de problemas', desc: 'Root cause analysis y workarounds documentados.' },
      { title: 'Base de conocimiento', desc: 'Artículos, self-service y resolución guiada.' },
      { title: 'CMDB', desc: 'Configuration items y relaciones entre servicios.' },
      { title: 'Reportes ITIL', desc: 'MTTR, MTBF, SLA compliance y trending.' },
    ],
    benefits: [
      'Estándar ITIL sin la complejidad de las herramientas legacy',
      'Self-service reduce tickets de nivel 1 hasta 40%',
      'CMDB vivo integrado con ITAM y monitoreo',
    ],
    targetUsers: 'Operaciones de TI, service desk, empresas adoptando mejores prácticas ITIL.',
  },
  {
    slug: 'integration-hub',
    name: 'Integration Hub',
    group: 'IT Operations',
    icon: 'Network',
    tagline: 'Conectores universales y orquestación de integraciones',
    description: 'Conecta sistemas heterogéneos con conectores listos para usar, API management y automatización de flujos de datos.',
    heroHighlight: 'Low-code · API-first · Event-driven',
    features: [
      { title: 'Conectores universales', desc: 'REST, SOAP, JDBC, SFTP, webhooks y SDK pre-construidos.' },
      { title: 'Orquestación visual', desc: 'Flujos multi-paso con transformaciones, mapping y enriquecimiento.' },
      { title: 'API management', desc: 'Publicación, versionado y control de acceso de APIs.' },
      { title: 'Event-driven', desc: 'Patrones pub/sub y procesamiento asíncrono.' },
      { title: 'Observabilidad', desc: 'Trazas, logs y métricas por integración.' },
    ],
    benefits: [
      'Integra en días lo que con iPaaS tradicional llevaría semanas',
      'Reutiliza conectores en toda la organización',
      'Observabilidad end-to-end de cada flujo',
    ],
    targetUsers: 'Arquitectos de sistemas, equipos de integración, departamentos de TI.',
  },
  {
    slug: 'app-engine',
    name: 'App Engine (Low-code)',
    group: 'IT Operations',
    icon: 'Blocks',
    tagline: 'Aplicaciones a medida sin escribir código',
    description: 'Construye aplicaciones empresariales con plantillas, workflows visuales y despliegue inmediato en la plataforma asisant.',
    heroHighlight: 'Plantillas · Workflows · Despliegue 1-click',
    features: [
      { title: 'Constructor visual', desc: 'Drag & drop de formularios, tablas y vistas.' },
      { title: 'Plantillas pre-built', desc: 'Casos de uso comunes listos para personalizar.' },
      { title: 'Workflows visuales', desc: 'Automatización de procesos con React Flow.' },
      { title: 'Permisos granulares', desc: 'Control de acceso por rol, campo y acción.' },
      { title: 'Despliegue rápido', desc: 'Publicación en producción en un clic.' },
    ],
    benefits: [
      'Democratiza el desarrollo: citizen developers activos en días',
      'Reduce el backlog del área de TI',
      'Aplicaciones gobernadas y seguras desde el diseño',
    ],
    targetUsers: 'Citizen developers, equipos de negocio, TI buscando acelerar entrega.',
  },

  // ============ CONNECTIVITY ============
  {
    slug: 'starlink-manager',
    name: 'Starlink Manager',
    group: 'Connectivity',
    icon: 'Satellite',
    tagline: 'Observabilidad, provisionamiento y consumos de tu flota Starlink',
    description: 'Observabilidad en tiempo real, provisionamiento de clientes, gestión de bolsas, paquetes de datos y control de consumos para flotas Starlink.',
    heroHighlight: 'Integrado con la API oficial de Starlink',
    features: [
      { title: 'Inventario de antenas', desc: 'Integrado con CSP y sincronizado con la API de Starlink.' },
      { title: 'Provisionamiento de clientes', desc: 'Alta de clientes y activación de service lines con flujos automáticos multi-tenant.' },
      { title: 'Gestión de bolsas de datos', desc: 'Bolsas compartidas o por cliente, con recargas, vigencias y reasignación.' },
      { title: 'Paquetes de datos y consumos', desc: 'Cuotas, precios flexibles y control de consumo con alertas automáticas.' },
      { title: 'Observabilidad en tiempo real', desc: 'Latencia, throughput, obstrucciones, ping drop y uptime de cada terminal, 24/7.' },
      { title: 'Mapa de terminales', desc: 'Capas: operativos, alertas y sin señal en tiempo real.' },
      { title: 'Facturación por consumo', desc: 'Control total_gb vs cuota y sincronización con tu billing con márgenes.' },
    ],
    benefits: [
      'Gestiona cientos de terminales desde una única consola',
      'Controla bolsas, paquetes de datos y consumos sin hojas de cálculo',
      'Alertas tempranas evitan outages en ubicaciones críticas',
    ],
    targetUsers: 'Operadores y revendedores Starlink, empresas con operaciones remotas.',
  },
  {
    slug: 'starlink-isv',
    name: 'Starlink para ISV',
    group: 'Connectivity',
    icon: 'Radio',
    tagline: 'Conectividad satelital embebida en tu SaaS',
    description: 'APIs y SDK para integrar conectividad Starlink en plataformas ISV con aprovisionamiento, billing y telemetría.',
    heroHighlight: 'White-label · API-first · Multi-tenant',
    features: [
      { title: 'API completa Starlink', desc: 'Aprovisionamiento, cambio de planes, billing y telemetría.' },
      { title: 'SDK para ISV', desc: 'Librerías para integrar en pocas líneas de código.' },
      { title: 'Multi-tenant', desc: 'Aísla la operación de cada cliente de tu SaaS.' },
      { title: 'White-label', desc: 'Personaliza la experiencia con tu marca.' },
      { title: 'Soporte operaciones remotas', desc: 'Casos de uso marítimo, minería, campo y contingencia.' },
    ],
    benefits: [
      'Añade conectividad satelital a tu SaaS sin construirla desde cero',
      'Monetización flexible con márgenes sobre planes',
      'Time-to-market reducido de meses a semanas',
    ],
    targetUsers: 'Proveedores de software independientes (ISV), integradores, plataformas verticales.',
  },

  // ============ PEOPLE & WORKPLACE ============
  {
    slug: 'hr-service-delivery',
    name: 'HR Service Delivery',
    group: 'People & Workplace',
    icon: 'UserCheck',
    tagline: 'Portal de empleados y casos de RRHH',
    description: 'Centraliza solicitudes de RRHH, onboarding, documentación y procesos con flujos automatizados y autoservicio.',
    heroHighlight: 'Portal · Casos · Onboarding · Documentos',
    features: [
      { title: 'Portal del empleado', desc: 'Autoservicio para consultas, solicitudes y documentos.' },
      { title: 'Gestión de casos', desc: 'Tickets de RRHH con SLA, enrutamiento y seguimiento.' },
      { title: 'Onboarding', desc: 'Checklists, aprobaciones y asignación de recursos nuevos empleados.' },
      { title: 'Gestión documental', desc: 'Contratos, nóminas y documentación legal centralizada.' },
      { title: 'Automatización', desc: 'Flujos estándar: vacaciones, permisos, certificados y más.' },
    ],
    benefits: [
      'Reduce tickets de RRHH hasta 50% con autoservicio',
      'Onboardings consistentes y auditables',
      'Cumplimiento documental listo para inspecciones',
    ],
    targetUsers: 'Departamentos de RRHH, gerentes, empleados de la organización.',
  },
  {
    slug: 'workplace-service-delivery',
    name: 'Workplace Service Delivery',
    group: 'People & Workplace',
    icon: 'Building',
    tagline: 'Reservas de espacios y experiencia del empleado',
    description: 'Gestión de oficinas, reservas de escritorios, salas y experiencia integral en el entorno de trabajo híbrido.',
    heroHighlight: 'Hot-desking · Mapas · Facilities',
    features: [
      { title: 'Reserva de espacios', desc: 'Escritorios, salas, aparcamiento y recursos compartidos.' },
      { title: 'Mapas de oficinas', desc: 'Visualización interactiva con ocupación en tiempo real.' },
      { title: 'Experiencia del empleado', desc: 'Notificaciones, incidencias de oficina y feedback.' },
      { title: 'Gestión de facilities', desc: 'Mantenimiento, proveedores y órdenes de trabajo.' },
    ],
    benefits: [
      'Optimiza el uso de espacio en modelos híbridos',
      'Simplifica la vida del empleado presencial',
      'Datos reales de ocupación para decisiones inmobiliarias',
    ],
    targetUsers: 'Facilities, administradores de oficinas, operaciones, empleados.',
  },
  {
    slug: 'help-desk',
    name: 'Help Desk',
    group: 'People & Workplace',
    icon: 'LifeBuoy',
    tagline: 'Soporte técnico moderno y sencillo',
    description: 'Sistema de tickets para gestionar incidencias y requerimientos de clientes con historial unificado y reporting.',
    heroHighlight: 'Tickets · SLA · Historial · Reportes',
    features: [
      { title: 'Tickets centralizados', desc: 'Email, portal, chat y API unificados en un inbox.' },
      { title: 'Asignación inteligente', desc: 'Reglas por categoría, prioridad y habilidades.' },
      { title: 'Historial de cliente', desc: 'Toda la comunicación y contexto en una vista.' },
      { title: 'SLA y escalamientos', desc: 'Compromisos medibles con alertas automáticas.' },
      { title: 'Reportes de rendimiento', desc: 'Métricas de equipo, agentes y satisfacción.' },
    ],
    benefits: [
      'Onboarding rápido para agentes nuevos',
      'Reduce tiempos de resolución con plantillas e IA',
      'Visibilidad ejecutiva del estado de soporte',
    ],
    targetUsers: 'Equipos de soporte, atención al cliente, empresas con usuarios finales.',
  },

  // ============ GOVERNANCE, RISK & COMPLIANCE ============
  {
    slug: 'grc',
    name: 'Governance, Risk & Compliance (GRC)',
    group: 'Governance, Risk & Compliance',
    icon: 'ClipboardCheck',
    tagline: 'Gobernanza, riesgo y cumplimiento integrados',
    description: 'Gestión de riesgos empresariales, políticas, auditorías y respuesta de cumplimiento en un framework unificado.',
    heroHighlight: 'Riesgos · Políticas · Auditoría · Incidentes',
    features: [
      { title: 'Gestión de riesgos', desc: 'Registro, valoración, tratamiento y monitoreo continuo.' },
      { title: 'Políticas', desc: 'Creación, aprobación, publicación y attestations.' },
      { title: 'Auditoría', desc: 'Planificación, ejecución, hallazgos y plan de acción.' },
      { title: 'Cumplimiento normativo', desc: 'Frameworks mapeados (ISO 27001, SOC 2, GDPR, etc.).' },
      { title: 'Incidentes de cumplimiento', desc: 'Tratamiento, RCA y acciones correctivas.' },
    ],
    benefits: [
      'Un único framework para múltiples certificaciones',
      'Evidencia continua, no point-in-time',
      'Reportes ejecutivos con estado real de madurez',
    ],
    targetUsers: 'Cumplimiento, riesgos, auditoría interna, empresas en entornos regulados.',
  },
  {
    slug: 'security-compliance',
    name: 'Seguridad y Cumplimiento',
    group: 'Governance, Risk & Compliance',
    icon: 'Shield',
    tagline: 'Auditoría, vulnerabilidades y postura de seguridad',
    description: 'Auditoría de seguridad, monitoreo de vulnerabilidades y cumplimiento normativo para tu infraestructura tecnológica.',
    heroHighlight: 'Vulnerabilidades · Hardening · Compliance',
    features: [
      { title: 'Auditoría de seguridad', desc: 'Escaneos programados y hallazgos con remediación.' },
      { title: 'Gestión de vulnerabilidades', desc: 'Priorización por CVSS y exposición.' },
      { title: 'Cumplimiento', desc: 'Evidencia automatizada para frameworks comunes.' },
      { title: 'Reportes de seguridad', desc: 'Postura, tendencias y exposición por unidad.' },
    ],
    benefits: [
      'Reduce la superficie de ataque de forma continua',
      'Prioriza lo que realmente importa con contexto de negocio',
      'Evidencia lista para auditores externos',
    ],
    targetUsers: 'Seguridad, TI, responsables de cumplimiento.',
  },
  {
    slug: 'legal-service-delivery',
    name: 'Legal Service Delivery',
    group: 'Governance, Risk & Compliance',
    icon: 'Scale',
    tagline: 'Casos legales, contratos y solicitudes jurídicas',
    description: 'Gestiona casos, contratos y solicitudes del área legal con workflows, plantillas y trazabilidad completa.',
    heroHighlight: 'Casos · Contratos · Expedientes · Plantillas',
    features: [
      { title: 'Casos legales', desc: 'Expedientes con documentos, partes y actividad.' },
      { title: 'Contratos', desc: 'Plantillas, cláusulas, aprobaciones y vencimientos.' },
      { title: 'Solicitudes jurídicas', desc: 'Portal para áreas de negocio con SLAs.' },
      { title: 'Seguimiento', desc: 'Timeline, tareas y recordatorios por expediente.' },
      { title: 'Reportes', desc: 'Carga por abogado, tipología y riesgos.' },
    ],
    benefits: [
      'Visibilidad ejecutiva del trabajo legal',
      'Plantillas aceleran la elaboración de contratos',
      'Evita vencimientos y plazos perdidos',
    ],
    targetUsers: 'Departamentos legales, bufetes, in-house counsel.',
  },
  {
    slug: 'business-continuity-management',
    name: 'Business Continuity Management',
    group: 'Governance, Risk & Compliance',
    icon: 'ShieldCheck',
    tagline: 'Planes de continuidad y gestión de crisis',
    description: 'Elabora planes de continuidad, análisis de impacto (BIA), simulacros y gestión de crisis end-to-end.',
    heroHighlight: 'BIA · DRP · Simulacros · Crisis',
    features: [
      { title: 'Planes de continuidad', desc: 'BCP y DRP documentados, versionados y accesibles.' },
      { title: 'BIA', desc: 'Análisis de impacto en el negocio por proceso crítico.' },
      { title: 'Gestión de crisis', desc: 'Comité, comunicaciones y decisiones en tiempo real.' },
      { title: 'Simulacros', desc: 'Ejercicios programados con lecciones aprendidas.' },
      { title: 'Reportes de resiliencia', desc: 'Madurez, cobertura y RTO/RPO reales.' },
    ],
    benefits: [
      'Demuestra resiliencia a clientes y reguladores',
      'Planes vivos, no documentos olvidados',
      'Respuesta coordinada cuando ocurre lo inesperado',
    ],
    targetUsers: 'Gestión de riesgos, operaciones, responsables de continuidad.',
  },
  {
    slug: 'esg-management',
    name: 'ESG Management',
    group: 'Governance, Risk & Compliance',
    icon: 'Leaf',
    tagline: 'Métricas ESG y reportes de sostenibilidad',
    description: 'Gestión de métricas Environmental, Social y Governance con reportes, workflows y evidencia de cumplimiento.',
    heroHighlight: 'E · S · G · Reportes · Iniciativas',
    features: [
      { title: 'Métricas ESG', desc: 'Ambiental, social y gobernanza en un solo lugar.' },
      { title: 'Reportes de sostenibilidad', desc: 'GRI, SASB, TCFD y frameworks locales.' },
      { title: 'Workflows de cumplimiento', desc: 'Revisión, validación y publicación.' },
      { title: 'Iniciativas', desc: 'Seguimiento de proyectos de impacto con KPIs.' },
      { title: 'Análisis de impacto', desc: 'Huella, materialidad y comparativas.' },
    ],
    benefits: [
      'Cumple con reguladores y stakeholders con evidencia',
      'Integra ESG en la operación, no como silo',
      'Reportes consistentes año tras año',
    ],
    targetUsers: 'Sostenibilidad, cumplimiento, responsabilidad social corporativa.',
  },

  // ============ INNOVATION & STRATEGY ============
  {
    slug: 'ai-agents',
    name: 'AI Agents & Assist',
    group: 'Innovation & Strategy',
    icon: 'Bot',
    tagline: 'Agentes IA y copilots para todos los procesos',
    description: 'Agentes de IA, copilots y automatización conversacional embebidos en cada módulo de la plataforma.',
    heroHighlight: 'Copilots · Chatbots · Análisis predictivo',
    features: [
      { title: 'Agentes IA', desc: 'Asistentes especializados por dominio y proceso.' },
      { title: 'Copilots', desc: 'Sugerencias contextuales en el flujo de trabajo.' },
      { title: 'Automatización conversacional', desc: 'Procesos completos vía chat o voz.' },
      { title: 'Chatbots inteligentes', desc: 'Self-service con razonamiento avanzado.' },
      { title: 'Análisis predictivo', desc: 'Forecast, detección de anomalías y recomendaciones.' },
    ],
    benefits: [
      'Productividad inmediata para usuarios de negocio',
      'IA gobernada, con trazabilidad y control de datos',
      'ROI medible en casos concretos, no demos',
    ],
    targetUsers: 'Innovación, TI, atención al cliente, cualquier área que quiera activar IA.',
  },
  {
    slug: 'plm',
    name: 'Product Lifecycle Management (PLM)',
    group: 'Innovation & Strategy',
    icon: 'Rocket',
    tagline: 'Ciclo de vida de productos de extremo a extremo',
    description: 'Captura de ideas, triage, requisitos, riesgos, KPIs, roadmap y aprobaciones para productos internos o comerciales.',
    heroHighlight: 'Ideas · Requisitos · Roadmap · KPIs',
    features: [
      { title: 'Captura de ideas', desc: 'Triage y scoring automáticos.' },
      { title: 'Estados de ciclo de vida', desc: 'Concepto, desarrollo, lanzamiento, mantenimiento, retirado.' },
      { title: 'Detalle de producto', desc: 'Requisitos, riesgos, KPIs y aprobaciones.' },
      { title: 'Roadmap visual', desc: 'Iniciativas y releases con dependencias.' },
      { title: 'Workflow de aprobaciones', desc: 'Etapas de gate con criterios claros.' },
    ],
    benefits: [
      'Alinea producto, ingeniería y negocio',
      'Decisiones basadas en datos, no en opiniones',
      'Portafolio priorizado y visible para la dirección',
    ],
    targetUsers: 'Equipos de producto, gerentes de producto, desarrollo.',
  },
  {
    slug: 'strategic-portfolio-management',
    name: 'Strategic Portfolio Management',
    group: 'Innovation & Strategy',
    icon: 'GitBranch',
    tagline: 'Roadmap, demanda y entrega ágil',
    description: 'Gestión del portafolio estratégico con roadmaps, demanda, proyectos, programas y soporte ágil/híbrido.',
    heroHighlight: 'Portafolio · Demanda · Proyectos · Ágil',
    features: [
      { title: 'Portafolio estratégico', desc: 'Alineación de inversiones con objetivos corporativos.' },
      { title: 'Roadmaps', desc: 'Vistas ejecutivas con escenarios y simulaciones.' },
      { title: 'Gestión de demanda', desc: 'Intake, priorización y capacidad.' },
      { title: 'Gestión de proyectos', desc: 'Gantt, tareas, riesgos y deliverables.' },
      { title: 'Entrega ágil', desc: 'Scrum/Kanban con integraciones nativas.' },
    ],
    benefits: [
      'Visión única del portafolio estratégico',
      'Gobierna sin ahogar la agilidad de los equipos',
      'Capacidad vs demanda siempre visible',
    ],
    targetUsers: 'Dirección, PMO, gerentes de programa y proyecto.',
  },
  {
    slug: 'field-service-management',
    name: 'Field Service Management',
    group: 'Innovation & Strategy',
    icon: 'Wrench',
    tagline: 'Despacho y gestión de técnicos en campo',
    description: 'Despacho dinámico, órdenes de trabajo, inventario móvil y visibilidad en tiempo real de equipos en campo.',
    heroHighlight: 'Despacho · Órdenes · Inventario móvil',
    features: [
      { title: 'Despacho dinámico', desc: 'Asignación óptima por habilidad, ubicación y SLA.' },
      { title: 'Órdenes de trabajo', desc: 'Ciclo completo: creación, ejecución y cierre.' },
      { title: 'Seguimiento en campo', desc: 'Ubicación, estado y firma digital.' },
      { title: 'Inventario técnico', desc: 'Stock en vehículo y reposición automática.' },
      { title: 'Reportes', desc: 'Productividad, first-time-fix y SLA.' },
    ],
    benefits: [
      'Más OTs por técnico al día con menos kilómetros',
      'Clientes satisfechos con ETAs precisos',
      'Cero papeleo con captura móvil',
    ],
    targetUsers: 'Servicios técnicos, mantenimiento, operaciones de campo.',
  },

  // ============ FINANCE & PROCUREMENT ============
  {
    slug: 'finops',
    name: 'Plataforma FinOps',
    group: 'Finance & Procurement',
    icon: 'TrendingDown',
    tagline: 'Optimiza el gasto cloud con visibilidad y gobierno',
    description: 'Visibilidad, gobernanza y asignación inteligente de recursos en entornos multi-cloud para reducir costos sin frenar la innovación.',
    heroHighlight: 'Showback · Chargeback · Optimización',
    features: [
      { title: 'Visibilidad de costos', desc: 'Gasto por cuenta, servicio, tag y unidad de negocio.' },
      { title: 'Gobernanza cloud', desc: 'Budgets, alertas y políticas de uso.' },
      { title: 'Asignación inteligente', desc: 'Showback/chargeback automatizado.' },
      { title: 'Optimización multi-cloud', desc: 'Rightsizing, reservas, savings plans y spot.' },
      { title: 'Reportes de ahorro', desc: 'Ahorros logrados y oportunidades pendientes.' },
    ],
    benefits: [
      'Reduce el gasto cloud 15-30% en el primer año',
      'Responsabiliza a cada equipo por su consumo',
      'Cultura FinOps con KPIs transparentes',
    ],
    targetUsers: 'Finanzas, arquitectos cloud, operaciones con gasto cloud significativo.',
  },
  {
    slug: 'procurement-operations',
    name: 'Procurement Operations',
    group: 'Finance & Procurement',
    icon: 'ShoppingCart',
    tagline: 'Compras, requisiciones y adquisiciones',
    description: 'Gestión de procesos de compra, aprobación de requisiciones, workspace de adquisiciones y optimización de gastos.',
    heroHighlight: 'P2P · Requisiciones · Aprobaciones',
    features: [
      { title: 'Procesos de compra', desc: 'P2P (procure-to-pay) digitalizado end-to-end.' },
      { title: 'Requisiciones', desc: 'Creación, aprobación y catálogo interno.' },
      { title: 'Workspace de adquisiciones', desc: 'Herramientas de comprador en un solo lugar.' },
      { title: 'Proveedores', desc: 'Onboarding, certificación y evaluación.' },
      { title: 'Optimización de gasto', desc: 'Análisis, consolidación y negociación.' },
    ],
    benefits: [
      'Tiempo de ciclo de compra menor a la mitad',
      'Cumplimiento con políticas automático',
      'Visibilidad del gasto por categoría y proveedor',
    ],
    targetUsers: 'Compras, aprovisionamiento, finanzas.',
  },
  {
    slug: 'supplier-lifecycle-management',
    name: 'Supplier Lifecycle Management',
    group: 'Finance & Procurement',
    icon: 'Users',
    tagline: 'Ciclo de vida del proveedor end-to-end',
    description: 'Onboarding, inteligencia, evaluación de desempeño y gestión contractual de proveedores en un flujo único.',
    heroHighlight: 'Onboarding · Performance · Contratos',
    features: [
      { title: 'Ciclo de vida', desc: 'Desde onboarding hasta offboarding documentado.' },
      { title: 'Onboarding', desc: 'KYC, compliance, documentación y datos bancarios.' },
      { title: 'Inteligencia', desc: 'Scoring de riesgo, noticias y señales externas.' },
      { title: 'Evaluación de desempeño', desc: 'KPIs, scorecards y planes de mejora.' },
      { title: 'Contratos', desc: 'Integrado con Legal Service Delivery.' },
    ],
    benefits: [
      'Proveedores confiables con riesgo controlado',
      'Onboarding rápido sin sacrificar cumplimiento',
      'Base de proveedores sana y productiva',
    ],
    targetUsers: 'Compras, abastecimiento, cadena de suministro.',
  },
];

// Grupos ordenados para el mega-menú
export const moduleGroups = [
  { name: 'Partners & Commerce', description: 'Partners, billing cloud y comercial' },
  { name: 'IT Operations', description: 'ITAM, ITSM e integración' },
  { name: 'Connectivity', description: 'Starlink y conectividad' },
  { name: 'People & Workplace', description: 'RRHH, oficinas y soporte' },
  { name: 'Governance, Risk & Compliance', description: 'Riesgo, seguridad y legal' },
  { name: 'Innovation & Strategy', description: 'IA, producto y portafolio' },
  { name: 'Finance & Procurement', description: 'FinOps, compras y proveedores' },
];

export const getModuleBySlug = (slug) =>
  modulesData.find((m) => m.slug === slug);

export const getModulesByGroup = (groupName) =>
  modulesData.filter((m) => m.group === groupName);
